import React from 'react';

export function AlogSources() {
  return <div>alog sources</div>;
}
